export const deliveryTypeOptions = [
  { label: "Metro", value: "metro" },
  { label: "Standard", value: "standard" },
  { label: "Express", value: "express" },
  { label: "Courier", value: "courier" },
  { label: "Other", value: "other" },
];